import { useTranslation } from 'react-i18next';

import { NoResultsStyled } from './NoResultsFound.styled';

export const NoResultsFound = () => {
  const { t } = useTranslation('general');

  return <NoResultsStyled>{t('noResultsFound')}</NoResultsStyled>;
};
